"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.VideoState=void 0;var t;(function(e){e.Resume="resume",e.Start="start"})(t||(exports.VideoState=t={}));
//# sourceMappingURL=VideoState.js.map
